import { render, staticRenderFns } from "./roleChannelUserMapping.vue?vue&type=template&id=7cf50179&scoped=true&"
import script from "./roleChannelUserMapping.vue?vue&type=script&lang=js&"
export * from "./roleChannelUserMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf50179",
  null
  
)

export default component.exports